export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || 'https://batamx.velintech.com'

export const apiUrl = {
  login: `/auth/login-customer`,
  firstTimeLogin: `/auth/first-change-password-customer`,
  product: {
    list: `/product/public`,
  },
  customForm: {
    list: `/service/public/custom-form`,
  },
  booking: {
    get: (bookingId: string) => `/service/public/booking/${bookingId}`,
    create: `/service/public/booking`,
    checkSlots: `/service/public/booking/slots`,
    customerList: `/service/customer-booking`,
    customerBooking: `/service/public/booking/customer`,
    customerRecent: `/service/public/booking/customer/recent`,
  },
  order: {
    get: (orderId: string) => `/order/public/${orderId}`,
  },
  /** Lease public read (invoice.sourceId = leaseId when sourceType is rental). batamx-service. */
  rental: {
    get: (leaseId: string) => `/v3/rental/lease/public/${leaseId}`,
  },
  /** Object rental self-serve: browse items and request one. batamx-service. */
  objectRental: {
    groups: `/v3/object-rental/public/group`,
    assets: `/v3/object-rental/public/asset`,
    chargePreview: `/v3/object-rental/public/charge-preview`,
    request: `/v3/object-rental/public/request`,
  },
  user: {
    list: `/user/public`,
  },
  project: {
    get: (code: string) => `/project/${code}`,
  },
  customerQr: {
    resolve: `/service/public/customer-qr/resolve`,
    saved: `/service/public/customer-qr/saved`,
  },
  service: {
    list: `/service/public`,
    listServiceTypes: `/service/public/service-types`,
    attendedBy: `/service/public/attended-by`,
  },
  invoice: {
    get: (invoiceId: string) => `/invoice/public/${invoiceId}`,
  },
  shortUrl: {
    get: (code: string) => `/short-url/${code}`,
  },
}
